
<template>
    <div id="nav">
        <div class="sidebar">
            <el-menu :router="true" :default-active="activeLink" class="el-menu-vertical-demo"
                     :class="{'hide-menu-mobile':isCollapse}" :collapse="isCollapse">
                <div class="hotel-details">
                    <div class="property-icon">
                        <span style="cursor: pointer">
                            <img v-if="true" src="../assets/NOTAXI.png"
                                 :class="{'size-36':isCollapse, 'size-48':!isCollapse}"
                                 alt="">
                            <home-icon v-else></home-icon>
                        </span>
                    </div>
                    <div class="property-name-code" v-if="!isCollapse">
                        <span>NOTAXI</span>
                    </div>
                    <div v-on:click="isCollapse=!isCollapse" class="hamburger">
                        <menu-icon class="burger-icon"></menu-icon>
                    </div>
                </div>
                <div>
                    <admin-home :isCollapse="isCollapse" :activeLink="activeLink"
                                v-if="active_home === 'admin-home'"></admin-home>
                    <taxi-home :isCollapse="isCollapse" :activeLink="activeLink"
                               v-else-if="active_home === 'taxi-home'"></taxi-home>
                    <bus-home :isCollapse="isCollapse" :activeLink="activeLink"
                              v-else-if="active_home === 'bus-home'"></bus-home>
                    <travel-home :isCollapse="isCollapse" :activeLink="activeLink"
                                 v-else-if="active_home === 'travel-home'"></travel-home>
                    <div v-else>Unauthorized</div>
                </div>
            </el-menu>
        </div>
        <div class="content-wrapper">
            <div class="header">
                <div class="hamburger" v-on:click="isCollapse=!isCollapse">
                    <menu-icon class="burger-icon"></menu-icon>
                </div>
                <div class="user">
                    <div class="logged-in-user" @click="showDropdown =! showDropdown"
                         @mouseleave="showDropdown = false">
                        <div class="paralel-item" :class="{'remove-border-radius': showDropdown}">
                            <user-icon class="user-icon"></user-icon>
                            <span>{{user.user_email}}</span>
                            <chevron-down-icon v-if="showDropdown === false" class="caret-icon">
                            </chevron-down-icon>
                            <chevron-up-icon v-else class="caret-icon"></chevron-up-icon>
                        </div>
                        <div class="paralel-item paralel-absolute-item" v-if="showDropdown" @click="logout()">

                            <log-out-icon></log-out-icon>
                            &nbsp; <span>Logout</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <!--                <event-management-folio></event-management-folio>-->
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>

    import CommonUtils from "../common/services/CommonUtils";
    // import HkHeader from "../common/components/hk-header";
    import mutations from "@/store/mutation_types";
    import {mapMutations, mapState} from "vuex";
    import AdminHome from "../components/home/AdminHome";
    import TaxiHome from "../components/home/TaxiHome";
    import BusHome from "../components/home/BusHome";
    import TravelHome from "../components/home/TravelHome";
    import {
        MenuIcon,
        UserIcon,
        ChevronUpIcon,
        ChevronDownIcon,
        LogOutIcon
    } from 'vue-feather-icons'

    export default {
        name: 'Home',
        components: {TravelHome, BusHome, TaxiHome, AdminHome, MenuIcon,UserIcon,ChevronUpIcon,ChevronDownIcon,LogOutIcon},
        data() {
            return {
                isCollapse: false,
                showDropdown: false,
                activeLink: '',
                loading: false,
                active_home: null
            }
        },
        methods: {
            ...mapMutations(['SET_USER_EMAIL']),
            logout() {
                CommonUtils.clearCookies();
                this.$router.push({
                    name: 'Login'
                });
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
            }),
        },

        beforeMount() {
            let user = CommonUtils.getCookie('user_email');
            let permission = CommonUtils.getCookie('role');
            if (permission === 'ADMIN') {
                this.active_home = 'admin-home'
            } else if (permission === 'BASE') {
                this.$router.push({
                    name: 'Requests'
                });
                this.active_home = 'taxi-home'
            } else if (permission === 'BUS') {
                this.$router.push({
                    name: 'Bus'
                });
                this.active_home = 'bus-home'
            } else if (permission === 'TRAVEL') {
                this.$router.push({
                    name: 'Travel'
                });
                this.active_home = 'travel-home'
            }
            this[mutations.SET_USER_EMAIL](user);
            if (!user) {
                this.$router.push({name: 'Login'})
            }
        }

    }
</script>
<style lang="scss" scoped>
    .packageIcon {
        width: 32px;
        height: 20px;
        color: #46A0FC
    }

    .user {
        padding: 10px;
        display: flex;
        justify-content: flex-end;

        .logged-in-user {
            position: relative;

            .paralel-item {
                padding-left: 10px;
                padding-right: 10px;
                color: #000;
                border: 1px solid #f0f4f7;
                height: 48px;
                border-radius: 4px;
                display: flex;
                align-items: center;

                .user-icon {
                    margin-right: 5px;
                }

                .caret-icon {
                    margin-left: 5px;
                }

                &:hover {
                    background-color: #fff;
                    border-color: #f0f4f7;
                    color: #000;
                    cursor: pointer;
                }

                &:not(.paralel-absolute-item) {
                    background-color: #fff;
                    border-color: #fff;
                    color: #000;
                    cursor: pointer;
                }
            }

            .remove-border-radius {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }

            .paralel-absolute-item {
                width: 100%;
                position: absolute;
                border: 1px solid #e6e6e6;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                top: 41px;
                color: #409EFF;
                background-color: #fff;
                z-index: 99;
            }
        }
    }

    #nav {
        display: flex;
    }

    .sidebar {
        border-right: 1px solid #e6e6e6;

        .el-menu {
            border-right: 0px;
            text-align: left;
        }

        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 220px;
        }

        .collapsed {
            background-color: grey;
        }

        .el-menu-vertical-demo {
            height: 100vh;
        }

        .hotel-details {
            min-height: 60px;
            padding: 0 20px;
            border-bottom: 1px solid #e6e6e6;
            display: flex;
            align-items: center;

            @media screen and (max-width: 768px) {
                border-bottom: 1px solid #e6e6e6;
                display: flex;
                flex: 1;
            }

            .property-name-code {
                display: flex;
                flex-direction: column;
                margin-top: 6px;
                margin-left: 10px;

                @media (max-width: 768px) {
                    flex: 3;
                }
            }

            .property-icon {
                @media screen and (max-width: 768px) {
                    display: flex;
                    flex: 1;
                    justify-content: space-between;
                }

                .size-36 {
                    width: 36px;
                }

                .size-48 {
                    width: 48px;
                }
            }

            .hamburger {
                display: none;
                cursor: pointer;
                border: 1px solid #e6e6e6;
                border-radius: 4px;
                height: 40px;
                align-items: center;
                justify-content: center;
                width: 40px;

                @media screen and (max-width: 768px) {
                    display: flex;
                }

            }

            .hamburger:hover {
                background-color: #e6e6e6;
            }

        }
    }

    .content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;

        .header {
            height: 60px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            padding: 0 20px;
            border-bottom: 1px solid #e6e6e6;

            .hamburger {
                cursor: pointer;
                margin-right: 20px;
                border: 1px solid #e6e6e6;
                border-radius: 4px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
            }

            .hamburger:hover {
                background-color: #e6e6e6;
            }

            .user-name {
                flex: 1;
                display: flex;
                justify-content: flex-end;

                .user {
                    position: relative;
                    cursor: pointer;
                    min-width: 50px;
                    user-select: none;

                    .user-details {
                        border: 1px solid #e6e6e6;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        padding: 5px;
                        background-color: #46A0FC;
                        color: #fff;

                        .user-icon {
                            margin-right: 5px;
                        }

                        .caret-icon {
                            margin-left: 5px;
                        }
                    }

                    .logout {
                        position: absolute;
                        padding: 5px;
                        border: 1px solid #e6e6e6;
                        border-radius: 4px;
                        top: 35px;
                        left: 0;
                        right: 0;
                        background-color: #fff;
                        z-index: 99;
                        display: flex;
                        align-items: center;

                        span {
                            margin-left: 5px;
                        }

                        &:hover {
                            background-color: #46A0FC;
                            color: white;
                        }
                    }
                }
            }
        }

        .content {

            .box-card {
                margin-bottom: 10px;
            }
        }
    }

</style>


